import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import List from '@nmx/template/dist/componentLibrary/components/List';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
// styles
import { ListItemStyled } from './styles';

export default () => (
  <SectionContainer
    id='legal-links-intro'
    backgroundVariant='lightB'
    themeType='lightTheme'>
    <Row align='center'>
      <Typography
        component='h2'
        nextElement='graphic'>
        Additional Legal Information
      </Typography>
    </Row>
    <Row>
      <Col medium={3}>
        <Typography
          component='h3'
          nextElement='typography'>
          Northwestern Mutual
        </Typography>
        <List reduced>
          <ListItemStyled>
            <Link
              id='additional-legal-information-security-and-privacy-document'
              variant='primaryDeemphasize'
              linkUrl='/security-and-privacy/'>
              Security and Privacy
            </Link>
          </ListItemStyled>
          <ListItemStyled>
            <Link
              id='additional-legal-information-online-privacy-statement'
              variant='primaryDeemphasize'
              linkUrl='/online-privacy-statement/'>
              Online Privacy Statement
            </Link>
          </ListItemStyled>
          <ListItemStyled>
            <Link
              id='additional-legal-information-third-party-statement'
              variant='primaryDeemphasize'
              linkUrl='/third-party-links/'>
              Third Party Links
            </Link>
          </ListItemStyled>
          <ListItemStyled>
            <Link
              id='additional-legal-information-customer-privacy-notice'
              variant='primaryDeemphasize'
              linkUrl='/customer-privacy-notice/'>
              Customer Privacy Notice
            </Link>
          </ListItemStyled>
          <ListItemStyled>
            <Link
              id='additional-legal-information-anti-fraud-efforts'
              variant='primaryDeemphasize'
              linkUrl='/anti-fraud-efforts/'>
              Anti Fraud Efforts
            </Link>
          </ListItemStyled>
          <ListItemStyled>
            <Link
              id='additional-legal-information-illinois-customers'
              variant='primaryDeemphasize'
              linkUrl='/illinois-customers/'>
              Illinois Customers
            </Link>
          </ListItemStyled>
          <ListItemStyled>
            <Link
              id='additional-legal-information-new-york-customers'
              variant='primaryDeemphasize'
              linkUrl='/new-york-customers/'>
              New York Customers
            </Link>
          </ListItemStyled>
          <ListItemStyled>
            <Link
              id='additional-legal-information-hipaa-privacy-notice'
              variant='primaryDeemphasize'
              linkUrl='/hipaa-privacy-notice/'>
              HIPAA Privacy Notice
            </Link>
          </ListItemStyled>
          <ListItemStyled>
            <Link
              id='additional-legal-information-social-media-guidelines'
              variant='primaryDeemphasize'
              linkUrl='/social-media-guidelines/'>
              Social Media Guidelines
            </Link>
          </ListItemStyled>
          <ListItemStyled>
            <Link
              id='additional-legal-information-transparency-in-health'
              variant='primaryDeemphasize'
              linkUrl='/assets/pdf/legal/transparency-in-health-coverage.pdf'>
              Transparency in Health Coverage
            </Link>
          </ListItemStyled>
        </List>
      </Col>
      <Col medium={3}>
        <Typography
          component='h3'
          nextElement='typography'>
          Northwestern Mutual Investment Services, LLC
        </Typography>
        <List reduced>
          <ListItemStyled>
            <Link
              id='additional-legal-information-client-relationship-summary'
              variant='primaryDeemphasize'
              linkUrl='/client-relationship-summary/'>
              Client Relationship Summary (Form CRS)
            </Link>
          </ListItemStyled>
          <ListItemStyled>
            <Link
              id='additional-legal-information-guide-to-brokerage-services'
              variant='primaryDeemphasize'
              linkUrl='/assets/pdf/brochures/guide-to-brokerage-services.pdf'
              isInternalPdf>
              Guide to Brokerage Services
            </Link>
          </ListItemStyled>
          <ListItemStyled>
            <Link
              id='additional-legal-information-investing-disclosures'
              variant='primaryDeemphasize'
              linkUrl='/investing-disclosure/'>
              Investing Disclosures
            </Link>
          </ListItemStyled>
          <ListItemStyled>
            <Link
              id='additional-legal-information-broker-dealer-information'
              variant='primaryDeemphasize'
              linkUrl='/broker-dealer-information/'>
              Broker Dealer Information
            </Link>
          </ListItemStyled>
          <ListItemStyled>
            <Link
              id='additional-legal-information-fee-schedule'
              variant='primaryDeemphasize'
              linkUrl='/assets/pdf/brochures/nmis-account-fee-schedule.pdf'
              isInternalPdf>
              Fee Schedule
            </Link>
          </ListItemStyled>
          <ListItemStyled>
            <Link
              id='additional-legal-information-business-continuity-plan'
              variant='primaryDeemphasize'
              linkUrl='/business-continuity-plan/'>
              Business Continuity Plan
            </Link>
          </ListItemStyled>
          <ListItemStyled>
            <Link
              id='additional-legal-information-variable-products-co'
              variant='primaryDeemphasize'
              linkUrl='/variable-products-compensation/'>
              Variable Products Compensation
            </Link>
          </ListItemStyled>
          <ListItemStyled>
            <Link
              id='additional-legal-information-guides-to-investing'
              variant='primaryDeemphasize'
              linkUrl='/guides-to-investing/'>
              Guides to Investing
            </Link>
          </ListItemStyled>
          <ListItemStyled>
            <Link
              id='additional-legal-information-order-routing-summary'
              variant='primaryDeemphasize'
              linkUrl='/order-routing-summary/'>
              Order Routing Summary
            </Link>
          </ListItemStyled>
        </List>
      </Col>
      <Col medium={3}>
        <Typography
          component='h3'
          nextElement='typography'>
          Northwestern Long Term Care Insurance Company
        </Typography>
        <List reduced>
          <ListItemStyled>
            <Link
              id='additional-legal-information-hipaa-privacy-notice-2'
              variant='primaryDeemphasize'
              linkUrl='/hipaa-privacy-notice-ltc/'>
              HIPAA Privacy Notice
            </Link>
          </ListItemStyled>
        </List>
      </Col>
      <Col medium={3}>
        <Typography component='h3'>
          Northwestern Mutual Wealth Management Company
        </Typography>
        <List reduced>
          <ListItemStyled>
            <Link
              id='additional-legal-information-client-relationship-summary-2'
              variant='primaryDeemphasize'
              linkUrl='/client-relationship-summary/'>
              Client Relationship Summary
            </Link>
          </ListItemStyled>
          <ListItemStyled>
            <Link
              id='additional-legal-information-advisory-program-disclosure-brochures'
              variant='primaryDeemphasize'
              linkUrl='/disclosure-brochures/'>
              Advisory Program Disclosure Brochures
            </Link>
          </ListItemStyled>
          <ListItemStyled>
            <Link
              id='additional-legal-information-investing-disclosures-2'
              variant='primaryDeemphasize'
              linkUrl='/investing-disclosure/'>
              Investing Disclosures
            </Link>
          </ListItemStyled>
        </List>
      </Col>
    </Row>
  </SectionContainer>
);

